
import '../App.css';

import { Environment, OrbitControls, Html, useProgress, useHelper, useGLTF, ScrollControls, Scroll } from '@react-three/drei';

import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { Canvas, useFrame, useLoader, useThree } from '@react-three/fiber'
import { Suspense, useEffect, useMemo, useRef, useState } from 'react';

import * as THREE from 'three'
import CameraControls from 'camera-controls'
import { Vector3 } from 'three';

import Renderif from '../utils/renderif';
import Map from '../map';
import { Astronaut } from '../components/models/astronaut';
import { Moon } from '../components/models/moon';
import { useNavigate } from 'react-router-dom';
import { IoIosArrowRoundBack } from 'react-icons/io';
// import { Octahedron } from '../../components/models/octahedron';
// import { DirectionalLightHelper } from 'three';
// // import { useNavigate } from 'react-router-dom';
// import CameraPositionLogger from '../../components/helpers/camera_position_logger';
// import { Island } from '../../components/models/island';



function Scene() {
 

//   const gltf = useLoader(GLTFLoader, 'models/island/scene.gltf')
// const { gltf } = useGLTF(
//     "https://virtual-school-models-bucket.s3.amazonaws.com/island/scene.gltf"
//   );
    // const gltf = useLoader(GLTFLoader, 'https://virtual-school-models-bucket.s3.amazonaws.com/island/scene.gltf')
    const gltf = useLoader(GLTFLoader, '/models/moon2/scene.gltf')
  
  return <primitive object={gltf.scene} scale={[50,50,50]} rotation={[0,0,0]} />
  
}

function Overlay (props){

    console.log(props.show)
    // const navigate = useNavigate()

    useEffect(()=>{
        console.log(props.show)
        if(!props.show){
            setTimeout(()=>{
                // navigate('/home')
            },3000)
        }
    },[props.show])

    return (
      <div className={`entry-overlay ${props.show ? 'opacity-0':''}`}>

    </div>
    )


}

function Loader() {
  const { progress } = useProgress()

  return (
    <Html >
        
        <div className='world-overlay'>
        <div className='d-flex flex-column align-items-center'>
            <div className='f-32 text-blue'>{progress.toFixed(0)}%</div>
            <div className='_progress'>
              <div className='_progress-bar' style={{width:progress+'%'}}></div>
            </div>
        </div>
        </div>
    </Html>
  )
}

CameraControls.install({ THREE })

function Cloud({ momentsData, zoomToView }) {
  return  <>

  {/* <mesh position={[-22, 20, 19]} onClick={(e) => {
    // zoomToView(e.object.position)
  }}>
    <boxGeometry args={[5,5,5]} />
    <octahedronGeometry  radius={10} />

    <meshStandardMaterial color={'red'} />
  </mesh> */}
  {/* <Octahedron scale={[2,2,2]}  position={[0, 38, 30]} onClick={(evt)=>{
   
    zoomToView(new Vector3(-40, 2, 40), new Vector3(-45, 2, 37))


  }}></Octahedron> */}

  <mesh position={[-47, 2, 36]} rotation={[0,1,1.6]} onClick={(e) => {
    <div></div>
    // zoomToView(e.object.position)
    // zoomToView(new Vector3(-35, 2, 42))
  }}>
    <boxGeometry args={[6,6,6]}  />
    <meshStandardMaterial color={'white'} />
  </mesh>
  </>
}

function Controls({ zoom, focus, target, pos = new THREE.Vector3(), look = new THREE.Vector3(), init }) {

    const camera = useThree((state) => state.camera)

    const gl = useThree((state) => state.gl)
    const controls = useMemo(() => new CameraControls(camera, gl.domElement), [])
    controls.enabled = false;

    // console.log(controls.camera.position)
    // controls.camera.position.set(230, 200,0)
    controls.camera.lookAt(new THREE.Vector3(0, 130, 0))


    // controls.setLookAt(230, 200,0, 0, 130, 0, false)
    // controls.update()

    // console.log(zoom)

    // if(zoom){
    //     controls.setLookAt(-40, 2, 40, -45, 2, 37, true)
    //     controls.update()
    // }

    let deltaCurrent = 0
    
    let clock = new THREE.Clock();
    let _delta = 0;
    // 30 fps
    let interval = 1 / 15;

    return useFrame((state, delta) => {
        
      

        _delta += clock.getDelta();

       if (_delta  > interval) {
           // The draw or time dependent code are here
       
            zoom ? pos.set(focus.x, focus.y, focus.z) : pos.set(230, 120, 0)
            zoom ? look.set(target.x, target.y, target.z ) : look.set(0, 0, 0)
        
            state.camera.position.lerp(pos, 0.4)

            state.camera.updateProjectionMatrix()
        
            controls.setLookAt(state.camera.position.x, state.camera.position.y, state.camera.position.z, look.x, look.y, look.z, true)
           _delta = _delta % interval;
           
       }
       return controls.update(delta)
        
        
        // zoom ? pos.set(focus.x, focus.y, focus.z) : pos.set(230, 120, 0)
        // zoom ? look.set(target.x, target.y, target.z ) : look.set(0, 0, 0)
    
        // state.camera.position.lerp(pos, init ? 0.2 : 0.4)

        // state.camera.updateProjectionMatrix()
    
        // controls.setLookAt(state.camera.position.x, state.camera.position.y, state.camera.position.z, look.x, look.y, look.z, true)

        // return controls.update(delta)
    })


}


function Light  () {
  const dirLight = useRef(null);
//   useHelper(dirLight, DirectionalLightHelper,1, "red");

  return (
    <>
       <directionalLight position={[0, 100, -100]} color={"white"} castShadow={true} intensity={5}  ref={dirLight} />
    </>
  );
};

function WebDevelopmentView() {
  const navigate = useNavigate()
  const [zoom, setZoom] = useState(false)
  const [focus, setFocus] = useState({})
  const [target, setTarget] = useState({})
  const [_init, _setInit] = useState(true)
  const [loading, setLoading] = useState(true)

  const { progress } = useProgress()

  const [call, setCall] = useState(false)

  const [state, setState] = useState({
    services_rotation:0,
    services_index:0,
  })
  // console.log(progress)



  
  const init = [230, 120, 0]
    useEffect(()=>{
        if(loading === true && progress == 100 ){
            setTimeout(()=>{
                setLoading(false)
            },100)
        }

    },[progress])

  return (
    <div className="App">


     


      {/* <Overlay show={_init}></Overlay> */}
     
      {/* <div className={`entry-overlay-2 ${!loading? 'opacity-0':''}`}>
        
        <div className={`flex-column justify-content-center align-items-center h-100 ${progress === 100 ? 'd-none':'d-flex'}`}>
            <div className='f-32 text-blue lighter'>{progress.toFixed(0)}%</div>
            <div className='_progress'>
              <div className='_progress-bar' style={{width:progress+'%'}}></div>
            </div>
        </div>

      </div>
     */}
      <Canvas  linear camera={{ fov:40, near:1, far:700, position:[230,0,0]}}
       shadows={true}>
        
        <Suspense fallback={null}>

            

            {/* <axesHelper args={[1000]}></axesHelper> */}
            
            {/* <hemisphereLight color={"red"} intensity={10} position={[0, 500, 0 ]} ></hemisphereLight> */}
            <ambientLight color={"#FFF"}  intensity={30} />
            {/* <Light></Light> */}
          
          {/* <directionalLight position={[0, 0, 0]} color={"white"} intensity={10} castShadow={true} /> */}
        
          {/* <Watermelon scale={[0.1,0.1,0.1]}></Watermelon> */}
          {/* <Pirate scale={[20,20,20]}></Pirate> */}
          {/* <Cloud  zoomToView={(focusRef, _target) => {
            _setInit(false)
            setZoom(true) 
            setFocus(focusRef) 
            setTarget(_target)
          }} /> */}

          {/* <mesh position={[0,10,0]} onClick={(e) => {
            // zoomToView(e.object.position)
          }}>
            <boxGeometry args={[5, 5, 5]} />
            <meshStandardMaterial color={'red'} />
          </mesh> */}

          {/* <Scene></Scene> */}
     
          <ScrollControls pages={3} damping={0.25}>

            <Scroll html>
            <div className='cta-back-page' onClick={()=>{
                  navigate(-1)
                }}>
                  <IoIosArrowRoundBack color='white' size={50} />
                </div>

                <div className="page d-flex flex-wrap justify-content-center align-items-center">

                  <div className='col-12 col-lg-5'></div>
                  <div className='col-12 col-lg-5'>
                      <div className='text-white f-title f-32 text-reflect-32 text-center mb-3'>Dedicated Web Development</div>
                      <div className='text-white f-16 f-primary  line-1 mt-5'>Más que ofrecer una presencia digital básica, en Fraktalweb creamos sitios web que funcionan como extensiones inteligentes de tu empresa. <br/> Nuestro proceso comienza con un análisis detallado de tus necesidades y de cómo un sitio web puede contribuir a tus objetivos estratégicos.  <br/> A través de un diseño innovador y tecnología avanzada, convertimos tu sitio en una plataforma integral y poderosa que va más allá de solo "estar en línea".</div>
                      <div className='container d-flex justify-content-center py-5'>
                        {/* <div className='cta'>START MISSION</div>
                        <div className='mx-3'></div> */}
                       {/* <div className='cta cta--outline' onClick={()=>{
                          window.open('https://fraktalweb.com/brief', '_blank')
                        }}>Start MISSION</div>
                         <div className='cta cta--outline ms-4' onClick={()=>{
                          window.open('https://bit.ly/AgendaLlamadaFKW','_blank')
                        }}>Agendar cita</div> */}
                      </div>
                  </div>
                  {/* <div className='fraktal-name'>FRAKTALWEB</div> */}
                </div>

                <div className="page d-flex flex-wrap justify-content-center align-items-center">

                <div className='col-12 col-lg-5'></div>
                <div className='col-12 col-lg-5'>
                    {/* <div className='text-white f-title f-32 text-reflect-32 text-center mb-3'>Dedicated Web Development</div> */}
                    <div className='text-white f-16 f-primary line-1'>Cada sitio web que creamos está optimizado para atraer y convertir a tu audiencia específica. <br/> Analizamos la mejor estructura y herramientas para facilitar una experiencia de usuario única y efectiva, ya sea a través de funcionalidades personalizadas o mediante la integración con sistemas que ya uses en tu empresa.<br/>  De este modo, aseguramos que el sitio no solo represente tu marca, sino que se convierta en un activo importante para su crecimiento.</div>
                    <div className='container d-flex justify-content-center py-5'>
                        {/* <div className='cta'>START MISSION</div>
                        <div className='mx-3'></div> */}
                      {/*   <div className='cta cta--outline' onClick={()=>{
                          window.open('https://fraktalweb.com/brief', '_blank')
                        }}>Start MISSION</div>
                         <div className='cta cta--outline ms-4' onClick={()=>{
                          window.open('https://bit.ly/AgendaLlamadaFKW','_blank')
                        }}>Agendar cita</div>*/}
                      </div>
                </div>
                {/* <div className='fraktal-name'>FRAKTALWEB</div> */}
                </div>

                <div className="page d-flex flex-wrap justify-content-center align-items-center">

               
                <div className='col-12 col-lg-5'>
                    {/*<div className='text-white f-title f-32 text-reflect-32 text-center mb-3'>Dedicated Web Development</div>*/}
                    <div className='text-white f-16 f-primary line-1'>Además, cada desarrollo es adaptable y escalable, lo que permite añadir nuevas funcionalidades o integraciones en el futuro. <br/> <br/> Esto asegura que tu sitio web crezca a la par de tu empresa, aportando un valor constante y fortaleciéndose como una herramienta de marketing digital de alto impacto.</div>
                    <div className='container d-flex justify-content-start py-5'>
                        {/* <div className='cta'>START MISSION</div>
                        <div className='mx-3'></div> */}
                        <div className='cta cta--outline' onClick={()=>{
                          window.open('https://fraktalweb.com/brief', '_blank')
                        }}>Start MISSION</div>
                         <div className='cta cta--outline ms-4' onClick={()=>{
                          window.open('https://bit.ly/AgendaLlamadaFKW','_blank')
                        }}>Agendar cita</div>
                      </div>
                </div>
                <div className='col-12 col-lg-5'></div>
                {/* <div className='fraktal-name'>FRAKTALWEB</div> */}
                </div>

               

             
            </Scroll>

            <Astronaut call={call}></Astronaut>
            {/* <Moon call={call}></Moon> */}
            
          </ScrollControls>
          {/* <OrbitControls /> */}
          {/* <Island></Island> */}
          {/* {
            !loading ? <Controls zoom={zoom} focus={focus} target={target} init={_init}/> : <></>
          }
           */}
         
       
          {/* <CameraPositionLogger event='click'></CameraPositionLogger> */}
          

        </Suspense>
      </Canvas>

     

      <div className='space-bg'>

        <div className='stars'></div>
        <div className='twinkling'></div>
      </div>






      

    




      <div className='d-none'>
        <button onClick={()=>{
        
          setZoom(true)
          setFocus(new Vector3(-20.75, 1, 20))
        }}> GO to 1</button>
    

        <div>

        <div className='border w-100'>
        {focus.x === undefined ? init[0] : focus.x}
       <input className='w-100' type='range' min={-200} max={200} value={focus.x === undefined ? init[0] : focus.x} step={1} onChange={(evt)=>{
             setZoom(true)
             setFocus(new Vector3(evt.currentTarget.value, focus.y, focus.z))
        }} />
       </div>

       <div className='border w-100'>
        {focus.y === undefined ? init[1] : focus.y}
       <input className='w-100' type='range' min={-200} max={200} value={focus.y === undefined ? init[1] : focus.y} step={1} onChange={(evt)=>{
             setZoom(true)
             setFocus(new Vector3(focus.x, evt.currentTarget.value, focus.z))
        }} />
       </div>

        <div className='border w-100'>
        {focus.z === undefined ? init[2] : focus.z}
        <input className='w-100' type='range' min={-200} max={200} value={focus.z === undefined ? init[2] : focus.z} step={1} onChange={(evt)=>{
             setZoom(true)
             setFocus(new Vector3(focus.x, focus.y, evt.currentTarget.value))
        }} />
        </div>
        </div>

        



         <button onClick={()=>{
            setZoom(true)
            setFocus(new Vector3(init[0], init[1], init[2]))
            setTarget(new Vector3(0,0,))
        }}> Reset</button>
      </div>
     
    
    </div>
  );
}

export default WebDevelopmentView;
